import type {Ref} from 'vue'
import {
    B2B_AUTH_EVENT,
    CHANGE_LOCALE_EVENT,
    CHANGE_PRICE_EVENT,
    EventBus,
    RESET,
    RESET_BOOKING_DATA,
    SEARCH_EVENT,
    FILTER_EVENT,
} from '@/utils/event-bus'
// @ts-ignore
import {axiosInstance} from '@/utils/axios-accessor'
import {appInstance} from '@/utils/app-accessor'
import {isEqual} from '@/utils/helpers'
import {addDays, format, isAfter} from 'date-fns'
import {persistentStore, toursStore} from '@/composables/store-accessor'
import {
    packageTourInfo as packageTourInfoBlank,
    searchResponse as searchResponseBlank,
    searchRequest as searchRequestBlank,
    filters as filtersBlank,
} from '@/utils/tours/tours-blank-states'
import {convertPrice} from '@/utils/filters'

const _runtimeFilters = () => ({})

export async function loadCity(point: any, id: any) {
    try {
        const {
            cities: [city],
        } = await appInstance.$api.locations.get({id, limitCities: 1})
        return {[point]: city}
    } catch (e) {
        return {[point]: {}}
    }
}

export const useToursRuntimeStore = defineStore('toursRuntime', () => {
    function _newSearch(searchRequest: any) {
        stopSearch()
        SET_OFFERS([])
        SET_RUNTIME_FILTERS(_runtimeFilters())
        toursStore.SET_SEARCH_RESPONSE(searchResponseBlank())
        toursStore.NEW_SEARCH(searchRequest)
    }

    function _newSingleTourSearch(searchRequest: any) {
        stopSingleTourSearch()
        toursStore.NEW_SINGLE_TOUR_SEARCH(searchRequest)
    }

    function _setSearchResponse(searchResponse: any) {
        if (toursStore.searchResponse.offers.length === searchResponse.offers.length) return
        //TODO Need to add price filter check as in other products
        toursStore.SET_FILTER({key: 'price', value: searchResponse.filters.price})
        const {offers, ...sr} = searchResponse
        sr.offers = new Array(offers.length)
        toursStore.SET_SEARCH_RESPONSE(sr)
        appInstance.$localForage.setItem('tours', offers)
        load(offers)
    }

    const packageTours: Ref<any[]> = ref([])

    const packageTourId: Ref = ref(null)
    const packageTourInfo = ref(packageTourInfoBlank())

    const searchActiveCount = ref(0)
    const searchCTS: Ref = ref(null)

    const singleTourSearchActiveCount = ref(0)
    const singleTourSearchCTS: Ref = ref(null)
    const singleTourSearchTimeoutInstance: Ref = ref(null)

    const departureCity: Ref = ref({})
    const arrivalCity: Ref = ref({})
    const offers: Ref<any[]> = ref([])

    const filterActiveCount = ref(0)
    const runtimeFilters: Ref = ref(_runtimeFilters())

    function START_FILTER() {
        filterActiveCount.value++
    }

    function STOP_FILTER() {
        filterActiveCount.value--
    }

    function SET_RUNTIME_FILTERS(filters: any) {
        runtimeFilters.value = filters
    }

    function SET_OFFERS(_offers: any) {
        offers.value = _offers
    }

    function START_SEARCH() {
        searchActiveCount.value++
    }

    function STOP_SEARCH() {
        searchActiveCount.value--
    }

    function START_SINGLE_TOUR_SEARCH() {
        singleTourSearchActiveCount.value++
    }

    function STOP_SINGLE_SEARCH() {
        singleTourSearchActiveCount.value--
        singleTourSearchCTS.value = null
        singleTourSearchTimeoutInstance.value = null
    }

    function SET_SINGLE_TOUR_SEARCH_CTS(cancelTokenSource: any) {
        singleTourSearchCTS.value = cancelTokenSource
    }

    function SET_SEARCH_CTS(cancelTokenSource: any) {
        searchCTS.value = cancelTokenSource
    }

    function SET_DEPARTURE_CITY(city: any) {
        departureCity.value = city
    }

    function SET_ARRIVAL_CITY(city: any) {
        arrivalCity.value = city
    }

    //TODO Need refactoring
    function SELECT_OFFER({offerKey, selectedOfferKey, selectedOfferKeys}: any) {
        const setSelected = (index: any, entryIndex: any) => {
            offers.value[index].entries[entryIndex].selectedOfferKey = selectedOfferKey
            if (selectedOfferKeys) {
                offers.value[index].entries[entryIndex].selectedOfferKeys = selectedOfferKeys
            }
        }
        const productOffersAdapter = (product: any) =>
            product.offers?.length ? product.offers : product.packageOffers?.length ? product.packageOffers : [product]
        offers.value.forEach((tour, index) => {
            if (tour.offerKey === offerKey) {
                const entryIndex = tour.entries.findIndex((entry: any) => {
                    if (entry.type === 'CAR') {
                        return entry.offer.offerKey === selectedOfferKey
                    } else {
                        return entry.offers?.find((offer: any) => {
                            if (offer.rooms) {
                                if (!selectedOfferKeys) {
                                    return offer.rooms?.find(
                                        (room: any) => room.groupedOffers[0].offerKey === selectedOfferKey
                                    )
                                } else {
                                    return offer.rooms?.find((room: any) =>
                                        selectedOfferKeys.includes(room.groupedOffers[0].offerKey)
                                    )
                                }
                            } else {
                                return productOffersAdapter(offer).find(
                                    (offer: any) => offer.offerKey === selectedOfferKey
                                )
                            }
                        })
                    }
                })
                if (entryIndex !== -1) {
                    if (offers.value[index].entries[entryIndex].obligatory) {
                        setSelected(index, entryIndex)
                        return false
                    } else if (!offers.value[index].entries[entryIndex].obligatory) {
                        const key = offers.value[index].entries[entryIndex].selectedOfferKey
                        if (key && key !== selectedOfferKey) {
                            setSelected(index, entryIndex)
                        } else if (!key) {
                            setSelected(index, entryIndex)
                        } else if (selectedOfferKeys) {
                            setSelected(index, entryIndex)
                        }
                        return false
                    }
                }
            }
        })
        appInstance.$localForage.setItem('tours', clone(offers.value))
        toursStore.UPDATE_OFFER({offerKey, selectedOfferKey, selectedOfferKeys})
    }

    //TODO Need refactoring
    function UNSELECT_OFFER({offerKey, selectedOfferKey}: any) {
        const productOffersAdapter = (product: any) =>
            product.offers?.length ? product.offers : product.packageOffers?.length ? product.packageOffers : [product]
        offers.value.forEach((tour, index) => {
            if (tour.offerKey === offerKey) {
                const entryIndex = tour.entries.findIndex((entry: any) => {
                    if (entry.type === 'CAR') {
                        return entry.offer.offerKey === selectedOfferKey
                    } else {
                        return entry.offers?.find((offer: any) => {
                            if (offer.rooms) {
                                return offer.rooms?.find(
                                    (room: any) => room.groupedOffers[0].offerKey === selectedOfferKey
                                )
                            } else {
                                return productOffersAdapter(offer).find(
                                    (offer: any) => offer.offerKey === selectedOfferKey
                                )
                            }
                        })
                    }
                })
                if (entryIndex !== -1 && !offers.value[index].entries[entryIndex].obligatory) {
                    delete offers.value[index].entries[entryIndex].selectedOfferKey
                }
            }
        })

        appInstance.$localForage.setItem('tours', clone(offers.value))
        toursStore.DELETE_OFFER_TOUR({offerKey, selectedOfferKey})
    }

    function UPDATE_ENTRIES(entries: any) {
        entries.forEach((entry: any) => {
            const index = offers.value[0].entries.findIndex(({entryName}: any) => entryName === entry.entryName)
            offers.value[0].entries[index] = entry
        })
    }

    async function loadPackageTours(request = {}) {
        try {
            packageTours.value = await appInstance.$api.packageTours.get(request)
        } catch (e) {
            packageTours.value = []
        }
    }

    async function loadPackageTourInfo(_packageTourId: any) {
        try {
            const _packageTourInfo = await appInstance.$api.packageTourInfo.get({packageTourId: _packageTourId})
            _packageTourInfo.itineraryDays.sort((a: any, b: any) => a.number - b.number)
            const locationResponses = await Promise.all(
                _packageTourInfo.locations.map((location: any) => appInstance.$api.locations.get({id: location.id}))
            )
            _packageTourInfo.locations = locationResponses.map(locationRs => locationRs.cities[0])
            _packageTourInfo.availabilities.forEach((availability: any) => {
                const defaultDate = addDays(new Date(), 1)
                if (isAfter(defaultDate, new Date(availability.startDateFrom))) {
                    availability.startDateFrom = format(defaultDate, 'yyyy-MM-dd')
                }
            })
            packageTourId.value = _packageTourId
            packageTourInfo.value = _packageTourInfo
        } catch (e) {
            packageTourId.value = _packageTourId
            packageTourInfo.value = packageTourInfoBlank()
        }
    }

    async function loadDepartureCity(id: any) {
        departureCity.value = (<any>await loadCity('departureCity', id))?.departureCity || {}
    }

    async function loadArrivalCity(id: any) {
        arrivalCity.value = (<any>await loadCity('arrivalCity', id))?.arrivalCity || {}
    }

    function clientInit() {
        EventBus.$on(RESET, reset)
        EventBus.$on(RESET_BOOKING_DATA, reset)
        EventBus.$on(B2B_AUTH_EVENT, reset)
        EventBus.$on(CHANGE_LOCALE_EVENT, reload)
        EventBus.$on(CHANGE_PRICE_EVENT, changePrice)
        appInstance.$workers.toursWorker.onmessage = ({data}: any) => {
            if (data === 'load') {
                if (isEqual({...filtersBlank(), price: toursStore.searchResponse.filters.price}, toursStore.filters)) {
                    sort()
                } else {
                    filter()
                }
                return
            } else if (data === 'refresh') {
                return
            }
            STOP_FILTER()
            if (filterActive.value) return
            SET_OFFERS(data)
            EventBus.$emit(FILTER_EVENT)
        }
    }

    async function changePrice({offerKey, prepareBookResponse}: any) {
        toursStore.REFRESH_BASKET_PRICE({offerKey, prepareBookResponse})
        persistentStore.REFRESH_CONDITIONS({offerKey, prepareBookResponse})
    }

    function reset() {
        if (searchCTS.value) searchCTS.value.cancel()
        _newSingleTourSearch(null)
        toursStore.RESET()
    }

    async function reload() {
        const promises = []
        if (packageTourId.value) promises.push(loadPackageTourInfo(packageTourId.value))
        if (departureCity.value.id) promises.push(loadDepartureCity(departureCity.value.id))
        if (arrivalCity.value.id) promises.push(loadArrivalCity(arrivalCity.value.id))

        await Promise.all(promises)
    }

    function newSearch() {
        _newSearch(searchRequestBlank())
    }

    function stopSearch() {
        if (searchCTS.value) searchCTS.value.cancel()
    }

    function newSingleTourSearch() {
        _newSingleTourSearch(null)
    }

    async function search(rq: any) {
        START_SEARCH()
        _newSearch(rq)
        EventBus.$emit(SEARCH_EVENT)
        try {
            // @ts-ignore
            const cancelTokenSource = axiosInstance.CancelToken.source()
            //SET_SEARCH_CTS(cancelTokenSource)
            const searchResponse = await appInstance.$api.searchPackageTours.get(rq, cancelTokenSource.token)
            _setSearchResponse(searchResponse)
            // eslint-disable-next-line no-empty
        } catch (e) {
        } finally {
            STOP_SEARCH()
        }
    }

    async function singleTourSearch(rq: any) {
        START_SINGLE_TOUR_SEARCH()
        _newSingleTourSearch(rq)
        EventBus.$emit(SEARCH_EVENT)
        try {
            // @ts-ignore
            const cancelTokenSource = axiosInstance.CancelToken.source()
            SET_SINGLE_TOUR_SEARCH_CTS(cancelTokenSource)
            const searchResponse = await appInstance.$api.searchPackageTours.get(rq)
            toursStore.SET_SINGLE_TOUR_SEARCH_RESPONSE(searchResponse)
            // eslint-disable-next-line no-empty
        } catch (e) {
        } finally {
            STOP_SINGLE_SEARCH()
        }
    }

    function stopSingleTourSearch() {
        if (singleTourSearchCTS.value) singleTourSearchCTS.value.cancel()
        if (singleTourSearchTimeoutInstance.value) singleTourSearchTimeoutInstance.value.cancel()
    }

    function load(offers = []) {
        appInstance.$workers.toursWorker.postMessage({action: 'load', offers})
    }

    function sort() {
        START_FILTER()
        appInstance.$workers.toursWorker.postMessage({action: 'sort', sortKey: toursStore.sortFnName})
    }

    function filter() {
        START_FILTER()
        appInstance.$workers.toursWorker.postMessage({
            action: 'filter',
            filters: clone({...toursStore.filters, ...runtimeFilters.value}),
            sortKey: toursStore.sortFnName,
        })
    }

    const searchActive = computed(() => {
        return searchActiveCount.value > 0
    })

    const singleTourSearchActive = computed(() => {
        return singleTourSearchActiveCount.value > 0
    })

    const touristsTotal = computed(() => {
        return (searchRequest: any) => searchRequest.adults + searchRequest.childrenAges.length
    })

    //TODO Need refactoring
    function totalPrice(tour: any) {
        const productOffersAdapter = (product: any) =>
            product.offers?.length ? product.offers : product.packageOffers?.length ? product.packageOffers : [product]
        const amount = tour?.entries?.reduce(
            (totalPrice: any, entry: any) => {
                let offerIndex
                if (!['ACCOMMODATION', 'CAR', 'EVENT', 'EXCURSION'].includes(entry.type)) {
                    offerIndex = entry.selectedOfferKey
                        ? entry.offers.findIndex((offer: any) => offer.offerKey === entry.selectedOfferKey)
                        : 0
                }
                let selectedOffer
                switch (entry.type) {
                    case 'ACCOMMODATION':
                        entry.offers.forEach((offer: any) => {
                            const calc = (room: any) => {
                                if (room) {
                                    if (entry.obligatory) {
                                        totalPrice += convertPrice(room.deltaPrice).amount || 0
                                    } else {
                                        totalPrice += convertPrice(room.notDeltaPrice).amount || 0
                                    }
                                }
                            }
                            if (entry.selectedOfferKeys) {
                                const rooms = offer.rooms.filter(({groupedOffers}: any) =>
                                    entry.selectedOfferKeys.includes(groupedOffers[0].offerKey)
                                )
                                rooms.forEach((room: any) => {
                                    calc(room)
                                })
                            } else {
                                const room = offer.rooms.find(
                                    ({groupedOffers}: any) => groupedOffers[0].offerKey === entry.selectedOfferKey
                                )
                                calc(room)
                            }
                        })
                        break
                    case 'EXCURSION':
                    case 'EVENT':
                        for (const product of entry.offers) {
                            for (const {deltaPrice, notDeltaPrice, offerKey} of product.offers) {
                                if (offerKey === entry.selectedOfferKey) {
                                    if (entry.obligatory) {
                                        totalPrice += convertPrice(deltaPrice).amount || 0
                                    } else {
                                        totalPrice += convertPrice(notDeltaPrice).amount || 0
                                    }
                                }
                            }
                        }
                        break
                    case 'EXTRA_SERVICE':
                        if (entry.selectedOfferKey && offerIndex >= 0) {
                            if (entry.obligatory) {
                                totalPrice += convertPrice(entry.offers[offerIndex].deltaPrice).amount || 0
                            } else {
                                totalPrice += convertPrice(entry.offers[offerIndex].notDeltaPrice).amount || 0
                            }
                        }
                        break
                    case 'FLIGHT':
                        if (entry.selectedOfferKey && offerIndex >= 0) {
                            if (entry.obligatory) {
                                totalPrice += convertPrice(entry.offers[offerIndex].deltaPrice).amount || 0
                            } else {
                                totalPrice += convertPrice(entry.offers[offerIndex].notDeltaPrice).amount || 0
                            }
                        }
                        break
                    case 'TRANSFER':
                        if (entry.selectedOfferKey && offerIndex >= 0) {
                            if (entry.obligatory) {
                                totalPrice += convertPrice(entry.offers[offerIndex].deltaPrice).amount || 0
                            } else {
                                totalPrice += convertPrice(entry.offers[offerIndex].notDeltaPrice).amount || 0
                            }
                        }
                        break
                    case 'INSURANCE':
                        if (entry.selectedOfferKey && offerIndex >= 0) {
                            if (entry.obligatory) {
                                totalPrice += convertPrice(entry.offers[offerIndex].deltaPrice).amount || 0
                            } else {
                                totalPrice += convertPrice(entry.offers[offerIndex].notDeltaPrice).amount || 0
                            }
                        }
                        break
                    case 'CRUISE':
                        if (entry.selectedOfferKey) {
                            for (const product of entry.offers) {
                                selectedOffer = productOffersAdapter(product).find(
                                    ({offerKey}: any) => offerKey === entry.selectedOfferKey
                                )
                                if (selectedOffer) break
                            }
                            if (entry.obligatory) {
                                totalPrice += convertPrice(selectedOffer.deltaPrice).amount || 0
                            } else {
                                totalPrice += convertPrice(selectedOffer.notDeltaPrice).amount || 0
                            }
                        }
                        break
                    case 'CAR':
                        if (entry.selectedOfferKey) {
                            if (entry.obligatory) {
                                totalPrice += convertPrice(entry.offer.deltaPrice).amount || 0
                            } else {
                                totalPrice += convertPrice(entry.offer.notDeltaPrice).amount || 0
                            }
                        }
                        break
                }

                return totalPrice
            },
            tour.price.amount ? convertPrice(tour.price).amount : 0
        )
        return {amount, currency: persistentStore.currency}
    }

    const hasFlightOffers = computed(() => {
        return (offer: any) =>
            offer.entries.findIndex(
                (entry: any) => ['FLIGHT', 'OWNCHARTER'].includes(entry.type) && entry.selectedOfferKey
            ) !== -1
    })

    const firstFlightOffer = computed(() => {
        return (offer: any) => {
            const entry = offer.entries.find((entry: any) => ['FLIGHT', 'OWNCHARTER'].includes(entry.type))
            return entry?.offers[0]
        }
    })

    const hasTransferOffers = computed(() => {
        return (offer: any) => offer.entries.findIndex((entry: any) => entry.type === 'TRANSFER') !== -1
    })

    const searchPageLink = computed(() => {
        return (searchRequest: any) => {
            const {...query} = searchRequest
            return {name: 'tourSearch', query}
        }
    })

    const filterActive = computed(() => {
        return filterActiveCount.value > 0
    })

    return {
        packageTours,
        packageTourId,
        packageTourInfo,
        searchActiveCount,
        searchCTS,
        singleTourSearchActiveCount,
        singleTourSearchCTS,
        singleTourSearchTimeoutInstance,
        departureCity,
        arrivalCity,
        offers,
        filterActiveCount,
        runtimeFilters,
        START_FILTER,
        STOP_FILTER,
        SET_RUNTIME_FILTERS,
        SET_OFFERS,
        START_SEARCH,
        STOP_SEARCH,
        START_SINGLE_TOUR_SEARCH,
        STOP_SINGLE_SEARCH,
        SET_SINGLE_TOUR_SEARCH_CTS,
        SET_SEARCH_CTS,
        SET_DEPARTURE_CITY,
        SET_ARRIVAL_CITY,
        SELECT_OFFER,
        UNSELECT_OFFER,
        UPDATE_ENTRIES,
        loadPackageTours,
        loadPackageTourInfo,
        loadDepartureCity,
        loadArrivalCity,
        clientInit,
        changePrice,
        reset,
        reload,
        newSearch,
        stopSearch,
        newSingleTourSearch,
        search,
        singleTourSearch,
        stopSingleTourSearch,
        load,
        sort,
        filter,
        searchActive,
        singleTourSearchActive,
        touristsTotal,
        totalPrice,
        hasFlightOffers,
        firstFlightOffer,
        hasTransferOffers,
        searchPageLink,
        filterActive,
    }
})

// TODO [P3] Need check this HRM improvement. Relates with https://pinia.vuejs.org/cookbook/hot-module-replacement.html#HMR-Hot-Module-Replacement-
if (import.meta.hot) import.meta.hot.accept(acceptHMRUpdate(useToursRuntimeStore, import.meta.hot))
